import { render, staticRenderFns } from "./GroupIcon.vue?vue&type=template&id=2ac0cd0b&"
import script from "./GroupIcon.vue?vue&type=script&lang=js&"
export * from "./GroupIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports